import { useEffect } from "react";
//context
import { useGlobalContext } from "../../contexts";
//apollo
import client from '../../src/utils/apollo/client';
//queries
import { GET_PRODUCTS_ARCHIVE } from "../../src/queries/products/get-products-archive";
//routing
import {handleRedirectsAndReturnData} from '../../src/utils/slug';
//components
import Layout from "../../src/components/layout"

const ArchiveProducts = ( { data } ) => {
  const { context, setContext } = useGlobalContext();

  useEffect(() => {
    if (!context.isSet) {
      data.context.options.isSet = true;
      setContext(data.context.options);
    }
  }, []);

	return (
    <Layout
      logos={data?.logos?.options?.logos}
      mainMenu={data?.mainMenu?.edges}
      menuFooter={data?.menuFooter?.edges}
      breadcrumbs={[
        {
          text: data?.seo?.contentTypes?.produit?.archive?.breadcrumbTitle,
          url: data?.seo?.contentTypes?.produit?.archive?.archiveLink?.replace(process.env.NEXT_PUBLIC_WORDPRESS_SITE, '')
        }
      ]}
      seo={data?.seo?.contentTypes?.produit?.archive}
      content={data?.content}
      pt_key={process.env.ARCHIVE_PRODUCTS_PT_KEY}
      templateWhite={false}
      programms={data?.programms}
      optionsFooter={'withContact'}
    >
    </Layout>
	);
};

export default ArchiveProducts;

export async function getStaticProps(context) {
	const { data, errors } = await client.query( {
		query: GET_PRODUCTS_ARCHIVE(process.env.ARCHIVE_PRODUCTS_PT_KEY),
    variables: {
      programmsCategoryId: parseInt(process.env.PRODUCT_PROGRAMM_CATEGORY_ID),
    }
	});


	const defaultProps = {
		props: {
			data: data || {}
		},
		revalidate: 60,
	};

	return handleRedirectsAndReturnData( defaultProps, data, errors, { allowNotFound: false } );
}